import React, { useContext, useEffect, useState } from 'react'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress,
  makeStyles
} from '@material-ui/core'
import { DatePicker, KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'

import MomentUtils from '@date-io/moment'
import moment from 'moment'

import clsx from 'clsx'

import Context from '../../context'

import { addMovieSession, getPartnerUnit, updateMovieSession } from '../../services/ClubeApi'

import history from '../../services/history'

function MovieSessionForm(props) {
  const classes = useStyles()

  const { message, movieToEdit } = props.location.state || {}

  const { setAboutCurrentPage } = useContext(Context)

  const [errors, setErrors] = useState(null)
  const [partnerList, setPartnerList] = useState([])
  const [loading, setLoading] = useState(false)
  const [formValues, setFormValues] = useState({
    date: new Date(),
    room: '',
    subtitled: 0,
    moviesId: 0,
    partnerUnitId: 0,
    purchaseUrl: '',
    id: 0
  })

  const onFormChanged = e => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value
    })
  }

  const checkErrors = () => {
    let errors = []

    if (!formValues.date.trim()) errors.push('Sem data')
    if (!formValues.moviesId.trim()) errors.push('Sem filme')
    if (!formValues.partnerUnitId.trim()) errors.push('Sem unidade parceira')
    if (!formValues.room.trim()) errors.push('Sem sala')

    return !!errors.length && errors
  }

  const hideErrorsModal = () => setErrors(null)

  const onSave = async () => {
    let errors = checkErrors()
    if (errors) {
      setErrors(errors)
      return
    }

    if (message !== undefined) {
      setLoading(true)

      await updateMovieSession(formValues)
      setLoading(false)

      // history.push('/sessions');
      return
    }

    setLoading(true)
    await addMovieSession(formValues)
    setLoading(false)

    history.push('/movies')
  }

  const partnerUnit = async () => {
    const response = await getPartnerUnit()
    setPartnerList(response.data)
  }

  useEffect(() => {
    partnerUnit()

    setAboutCurrentPage({
      title:
        message && movieToEdit !== undefined ? `Nova sessão - ${message.title}` : 'Nova Sessão',
      buttons: [{ title: 'Voltar', pathname: '/sessions' }]
    })

    if (message !== undefined) {
      console.log('aqui')
      setFormValues({
        date: message.date,
        room: message.room,
        subtitled: message.subtitled,
        moviesId: message.moviesId,
        partnerUnitId: message.partnerUnitId,
        purchaseUrl: message.purchaseUrl,
        id: message.id
      })

      setFormValues({
        moviesId: message.id
      })
    }
  }, [])

  return (
    <>
      <div className={classes.outerContainer}>
        {loading ? <LinearProgress /> : null}
        <div className={classes.content}>
          <div className={classes.main}>
            <div className={classes.inputGroup}>
              <span>Data</span>
              <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale="pt-br">
                <DatePicker
                  name="date"
                  format="L"
                  value={formValues.date}
                  onChange={mmt =>
                    setFormValues({
                      ...formValues,
                      date: mmt.format('YYYY-MM-DD')
                    })
                  }
                />
              </MuiPickersUtilsProvider>
            </div>

            <div className={classes.inputGroup}>
              <span>Hora</span>
              <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale="pt-br">
                <KeyboardTimePicker
                  margin="normal"
                  id="time-picker"
                  value={formValues.date}
                  onChange={e => {
                    const newDate = `${formValues.date} ${e.format('HH:mm:ss')}`
                    setFormValues({
                      ...formValues,
                      date: newDate
                    })
                  }}
                />
              </MuiPickersUtilsProvider>
            </div>

            <div className={classes.inputGroup}>
              <span>Sala</span>
              <input name="room" value={formValues.room} onChange={e => onFormChanged(e)} />
            </div>

            <div className={classes.inputGroup}>
              <span>Parceiro</span>
              <select
                name="partnerUnitId"
                value={formValues.partnerUnitId}
                onChange={e => onFormChanged(e)}
              >
                {partnerList.map(item => (
                  <>
                    {item.PartnerUnits.map(partnerUnit => (
                      <option value={partnerUnit.id} key={partnerUnit.id}>
                        {partnerUnit.fantasyName}
                      </option>
                    ))}
                  </>
                ))}
              </select>
            </div>
          </div>

          <div className={classes.aside}>
            <button
              className={clsx(classes.shadowButton, classes.fullRowTwoColumns)}
              type="button"
              onClick={onSave}
            >
              Publicar
            </button>
          </div>
        </div>
      </div>

      <Dialog
        open={!!errors}
        onClose={hideErrorsModal}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>Erros encontrados</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Encontramos os seguintes erros:
            <ul>
              {errors?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            Corrija-os antes de prosseguir.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={hideErrorsModal}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

const useStyles = makeStyles({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Montserrat',
    fontWeight: '500',
    '& label': {
      margin: '0 !important'
    }
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: '45px'
  },
  main: {
    flexGrow: 1,
    display: 'grid',
    flexDirection: 'auto',
    marginRight: 30,
    gap: '30px'
  },
  group: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr) min-content',
    alignItems: 'end',
    padding: '30px',
    gap: '20px 30px',
    backgroundColor: '#ece5fe',
    borderRadius: '4px'
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    '& > span': {
      fontSize: '16px',
      fontWeight: 700,
      color: '#30287b'
    },
    '& > input, & > div, & textarea, & select': {
      marginTop: '10px',
      background: '#fff',
      border: '2px solid #30287b !important',
      '&[disabled]': {
        opacity: 1,
        background: '#0000000a'
      }
    },
    '& input, & textarea, & select': {
      padding: '11px 13px',
      fontSize: '14px',
      color: '#30287b',
      border: 'none'
    },
    '& > div': {
      display: 'flex',
      flexDirection: 'row'
    },
    '& > div input, & > div select': {
      flexGrow: 1,
      height: '100%'
    },
    '& > input, & > div, & select': {
      height: 44
    },
    '& textarea': {
      minHeight: 132,
      resize: 'none'
    }
  },
  dateInputGroup: {
    width: 'fit-content',
    '& *::before': {
      display: 'none !important'
    },
    '& *::after': {
      display: 'none !important'
    }
  },
  divider: {
    marginTop: '15px',
    borderBottom: '2px solid #b294ff'
  },
  divider2: {
    margin: '10px -30px',
    borderBottom: '2px solid #b294ff'
  },
  subtitle: {
    margin: '15px 0 0',
    fontFamily: 'Matrice',
    fontSize: '18px',
    color: '#30287b'
  },
  subtitle2: {
    height: '25px',
    margin: '10px 0 0',
    fontFamily: 'Matrice',
    fontSize: '16px',
    color: '#30287b',
    lineHeight: '25px'
  },
  aside: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, auto)',
    width: 340,
    gap: '15px'
  },
  fullRowTwoColumns: {
    gridColumn: '1 / 3'
  },
  fullRowThreeColumns: {
    gridColumn: '1 / 4'
  },
  box: {
    border: '2px solid #30287b',
    '& h4': {
      marginBottom: 0,
      fontSize: '14px',
      fontWeight: '700',
      color: '#ffffff',
      lineHeight: '44px',
      textAlign: 'center',
      textTransform: 'uppercase',
      background: '#30287b',
      borderBottom: '2px solid #30287b'
    },
    '& > div': {
      display: 'grid',
      gridTemplateColumns: 'auto',
      gap: '15px',
      padding: '30px'
    },
    '& table': {
      width: '100%',
      '& td': {
        padding: '15px',
        color: '#30287b'
      },
      '& tbody td:first-child': {
        fontSize: '18px',
        fontWeight: 700,
        textAlign: 'center'
      },
      '& tbody td:nth-child(2)': {
        overflow: 'hidden',
        width: '100%',
        fontSize: '14px',
        fontWeight: 700,
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
      },
      '& tbody td:last-child': {
        fontSize: '14px',
        fontWeight: 500,
        whiteSpace: 'nowrap'
      },
      '& tfoot': {
        fontSize: '12px',
        fontWeight: 700,
        textAlign: 'center',
        textTransform: 'uppercase',
        borderTop: '2px solid #30387b',
        cursor: 'pointer'
      }
    }
  },
  plainButton: {
    display: 'block',
    width: '100%',
    margin: '0',
    padding: '0 20px',
    fontSize: '12px',
    fontWeight: '700',
    color: '#30287b',
    lineHeight: '44px',
    textAlign: 'center',
    textTransform: 'uppercase',
    background: '#ece5fe',
    border: 'none',
    borderRadius: '2px',
    cursor: 'pointer'
  },
  plainButton2: {
    display: 'block',
    margin: '2px',
    padding: '6px 5px',
    fontSize: '11px',
    fontWeight: '700',
    color: '#30287b',
    lineHeight: '24px',
    textAlign: 'center',
    textTransform: 'uppercase',
    background: '#ece5fe',
    border: 'none',
    borderRadius: '2px',
    cursor: 'pointer'
  },
  plainButtonRed: {
    color: '#fff',
    background: '#d73f32'
  },
  plainButtonGreen: {
    color: '#fff',
    background: '#13735e'
  },
  shadowButton: {
    width: '100%',
    fontSize: '12px',
    fontWeight: '700',
    color: '#30287b',
    lineHeight: '44px',
    textAlign: 'center',
    textTransform: 'uppercase',
    background: '#fbbb33',
    border: 'none',
    borderRadius: '2px',
    boxShadow: '4px 4px #4200f5',
    cursor: 'pointer'
  },
  img: {
    width: '100%',
    height: 'auto'
  },
  hiddenInput: {
    visibility: 'hidden',
    opacity: 0,
    position: 'absolute',
    width: 0,
    height: 0,
    margin: 0,
    padding: 0
  },
  legend: {
    fontSize: '12px',
    fontStyle: 'italic',
    color: '#30287b',
    textAlign: 'center'
  },
  ul: {
    listStyle: 'none',
    margin: '15px 0',
    padding: '0',
    '& li': {
      margin: '6px 0 0',
      fontSize: '14px',
      fontStyle: 'italic',
      color: '#30287b'
    }
  },
  correctTag: {
    display: 'inline-block',
    marginLeft: '16px',
    padding: '5px 12px',
    fontFamily: 'Montserrat',
    fontSize: '12px',
    fontWeight: 600,
    color: '#fff',
    lineHeight: '15px',
    backgroundColor: '#13735e',
    borderRadius: 2
  },
  excludeAnswer: {
    display: 'inline-block',
    marginLeft: '16px',
    padding: '5px 12px',
    fontFamily: 'Montserrat',
    fontSize: '12px',
    fontWeight: 600,
    color: '#fff',
    lineHeight: '15px',
    backgroundColor: '#d73f32',
    borderRadius: 2,
    cursor: 'pointer'
  },
  noPadding: {
    padding: '0 !important'
  },
  checkbox: {
    paddingLeft: 0,
    paddingRight: 0,
    color: '#30287b'
  },
  end: {
    justifySelf: 'end',
    width: 'fit-content'
  },
  addButton: {
    justifySelf: 'center',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '11px 15px',
    fontSize: '12px',
    fontWeight: 700,
    color: '#30287b',
    lineHeight: '15px',
    textTransform: 'uppercase',
    border: '2px solid #30287b',
    borderRadius: 4,
    cursor: 'pointer',
    '& svg': {
      marginRight: '6px',
      fontSize: '18px'
    }
  },
  pointer: {
    cursor: 'pointer'
  }
})

export default MovieSessionForm
